
export enum KentRecordType  {           
        Monument = "mon",     
        Source = "source",
        Designation = "desig",
        HistoricLandscapeCharacterisation = "hlc",
        AreaBoundary = "bound",
        DoverCharacterisation = "dc"
}  

export enum KentRecordSubType  {   
    ConservationArea = "COA",
    ScheduledMonument = "SM",
    HistoricParksAndGardens = "HPG",    
    RegisteredParksAndGardens = "RPG",
    ListedBuilding = "LB",
    PostMedieval1908 = "PM1908",
    PostMedieval1865 = "PM1865",
    PostMedieval1638to1641 = "PM1641",
    Medieval = "M",
    Harbour1500 = "H1500",
    AngloSaxon = "AS",
    LateRoman = "LR",
    EarlyRoman = "ER"
}  

